import { useEffect } from "react";

export const usePageMetadata = ({ title, canonicalPath, noIndex = false }) => {
  useEffect(() => {
    const previousTitle = document.title;
    const existingCanonical = document.querySelector('link[rel="canonical"]');
    const canonical = existingCanonical || document.createElement("link");
    const previousCanonical = existingCanonical?.getAttribute("href");
    if (!existingCanonical) {
      canonical.rel = "canonical";
      document.head.appendChild(canonical);
    }
    canonical.href = new URL(canonicalPath, window.location.origin).toString();

    const existingRobots = document.querySelector('meta[name="robots"]');
    const robots = existingRobots || document.createElement("meta");
    const previousRobots = existingRobots?.getAttribute("content");
    if (!existingRobots) {
      robots.name = "robots";
      document.head.appendChild(robots);
    }
    robots.content = noIndex ? "noindex, nofollow" : "index, follow";
    document.title = title;

    return () => {
      document.title = previousTitle;
      if (existingCanonical) canonical.setAttribute("href", previousCanonical || "");
      else canonical.remove();
      if (existingRobots) robots.setAttribute("content", previousRobots || "");
      else robots.remove();
    };
  }, [title, canonicalPath, noIndex]);
};

